<style lang="scss" scoped>
.user-list {
	min-height: 200px;
}
</style>

<template lang="pug">
el-card.no-padding.user-list(v-loading="$apollo.loading  || loading")
	template(v-if="!$apollo.loading || !loading")
		el-table(ref="multipleTable", :data="UsersFiltered", style="width: 100%", @selection-change="handleSelectionChange")
			el-table-column(type="selection", width="80", align='left')
			el-table-column(property="display_name", label="Name")
				template(slot-scope="scope")
					strong {{ scope.row.display_name }}
			el-table-column(property="company_name", label="company")
			el-table-column(property="email", label="email", :show-overflow-tooltip="true")
			el-table-column(property="role", label="role", align='center', width="170")
				template(slot-scope="scope")
					el-tag(size="small") {{ scope.row.role }}
			template(slot="empty")
				empty No team mates found
</template>

<script>
import gql from "graphql-tag";
import { uniqBy } from "lodash";
import { onLogin } from "@/vue-apollo";
import UserCompaniesQuery from "@/graphql/queries/UserCompanies.js";

export default {
	data() {
		return {
			loading: false,
			Users: { results: [] }
		};
	},

	apollo: {
		User: {
			query: UserCompaniesQuery
		},
		Users: {
			query: gql`
				query Users($page: Int) {
					Users(cursor: $page) {
						results {
							id
							email
							display_name
							company_id
							company_name
							role
							allow_force_login
						}
						cursor
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			variables() {
				return {
					page: 1
				};
			}
		}
	},

	computed: {
		UsersFiltered: function() {
			if (this.Users) {
				return uniqBy(this.Users.results, "id");
			}
			return [];
		},
		isWondeStaff() {
			return this.User ? this.User.Companies.some(c => c.slug == "wonde") : false;
		}
	},

	methods: {
		handleSelectionChange(val) {
			this.$emit("update-selection", val);
		}
	}
};
</script>
